import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Path = styled.path`
  fill: var(--color-base-1);
  stroke: var(--color-divider);
`;

const WinnerCardBgIcon = (props) => {
  const { width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 170 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path d="M114.33 29.5C114.33 31.9929 114.01 34.4116 113.408 36.7191C112.991 38.3188 113.328 40.0028 114.179 41.2897C115.033 42.5807 116.427 43.5 118.125 43.5L162 43.5C166.142 43.5 169.5 46.8579 169.5 51V108C169.5 112.142 166.142 115.5 162 115.5H8C3.85786 115.5 0.5 112.142 0.5 108V51C0.5 46.8579 3.85786 43.5 8 43.5L51.5344 43.5C53.2326 43.5 54.6261 42.5807 55.4799 41.2897C56.3309 40.0028 56.6677 38.3188 56.2508 36.7191C55.6494 34.4116 55.3296 31.9929 55.3296 29.5C55.3296 13.4916 68.5292 0.5 84.8296 0.5C101.13 0.5 114.33 13.4916 114.33 29.5Z" />
    </svg>
  );
};

WinnerCardBgIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

WinnerCardBgIcon.defaultProps = {
  width: 14,
  height: 24
};

export default WinnerCardBgIcon;
